import React, { Component } from 'react';
import ReactPlayer from 'react-player/lazy';
import { Link } from 'react-router-dom';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  Accordion,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import ProfServdata from './help1.json';
import Profdata from './help2.json';
import Otherdata from './help3.json';
import CookieBlockedIframe from '../../components/CookieBlockedIframe/CookieBlockedIframe';
import css from './HelpPage.module.css';

import { ButtonTabNavHorizontal } from '../../components/TabNavHorizontal/TabNavHorizontal';

export class HelpPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // keep track of which Help tab to show in desktop viewport
      isBSL: false,
      isText: true,
    };
  }

  showBSLHelp = () => {
    this.setState({
      isBSL: true,
      isText: false,
    });
  };

  showTextHelp = () => {
    this.setState({
      isText: true,
      isBSL: false,
    });
  };

  render() {
    const buttonTabs = [
      { text: 'Text', onClick: this.showTextHelp, selected: this.state.isText },
      { text: 'BSL', onClick: this.showBSLHelp, selected: this.state.isBSL },
    ];

    return (
      <StaticPage
        title="Help"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'HelpPage',
          description: 'Signalise - Help',
          name: 'Help',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Question 1?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Answer: Lorem ipsum',
              },
            },
          ],
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className={css.mainWrapper}>
            <h1>Help</h1>

            <ButtonTabNavHorizontal
              eventKey="text"
              title="English"
              tabs={buttonTabs}
              id="controlled-tab-example"
              className={css.tab}
            />

            <h2>If you need to book the services of a communication professional:</h2>

            {this.state.isText ? (
              <Accordion allowMultipleOpen className={css.accordion}>
                {ProfServdata.map(post => (
                  <div
                    className={css.title}
                    key={post.id.toString()}
                    label={post.title}
                  >
                    <p
                      className={css.cardContent}
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                  </div>
                ))}
              </Accordion>
            ) : (
              <Accordion allowMultipleOpen>
                {ProfServdata.map(post => (
                  <div
                    key={post.id.toString()}
                    className={css.label}
                    label={post.title}
                  >
                    <div className={`${css.label} ${css.playerWrapper}`}>
                      <CookieBlockedIframe
                        src={`${post.video}?rel=0&autoplay=1&origin=https://signalise.coop`}
                        //width="100%"
                        //height="100%"
                        serviceName="youtube"
                      />
                    </div>
                  </div>
                ))}
              </Accordion>
            )}
            <h2>If you are a communication professional:</h2>

            {this.state.isText ? (
              <Accordion allowMultipleOpen className={css.accordion}>
                {Profdata.map(post => (
                  <div key={post.id.toString()} label={post.title}>
                    <p
                      className={css.cardContent}
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                  </div>
                ))}
              </Accordion>
            ) : (
              <Accordion allowMultipleOpen>
                {Profdata.map(post => (
                  <div
                    key={post.id.toString()}
                    className={css.label}
                    label={post.title}
                  >
                    <div style={{ paddingBottom: '56.25%' }} className={css.label}>
                      <ReactPlayer
                        url={`${post.video}?rel=0&amp;autoplay=1&amp;origin=https://signalise.coop`}
                        className={css.reactPlayer}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </div>
                ))}
              </Accordion>
            )}

            <h2>Other questions:</h2>

            {this.state.isText ? (
              <Accordion allowMultipleOpen className={css.accordion}>
                {Otherdata.map(post => (
                  <div key={post.id.toString()} label={post.title}>
                    <p
                      className={css.cardContent}
                      dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                  </div>
                ))}
              </Accordion>
            ) : (
              <Accordion allowMultipleOpen>
                {Otherdata.map(post => (
                  <div
                    key={post.id.toString()}
                    className={css.label}
                    label={post.title}
                  >
                    <div style={{ paddingBottom: '56.25%' }} className={css.label}>
                      <ReactPlayer
                        url={`${post.video}?rel=0&amp;autoplay=1&amp;origin=https://signalise.coop`}
                        className={css.reactPlayer}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </div>
                ))}
              </Accordion>
            )}
            <div className={css.additionalHelp}>
              <h3>Didn't find what you're looking for? </h3>
              <p>
                We have our <Link to="faq">FAQs &#40;frequently asked questions&#41;</Link> page
                where you can read more about us and the benefits of using our service. You can also
                get in touch via <a href="mailto:hello@signalise.coop">hello@signalise.coop</a>.
              </p>
            </div>
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </StaticPage>
    );
  }
}
export default HelpPage;
